const errors = {
    failedToLoadAutomationNodes: 'Automationsknoten konnten nicht geladen werden',
    // General
    somethingWentWrong: 'Etwas ist schief gelaufen',
    tryAgain: 'Bitte versuchen Sie es erneut',
    failedToLoadApplication: 'Anwendung konnte nicht geladen werden',
    
    // Billing Configuration
    failedToLoadBillingConfiguration: 'Abrechungskonfiguration konnte nicht geladen werden',
    failedToSaveBillingConfiguration: 'Abrechnungskonfiguration konnte nicht gespeichert werden',
    atLeastOnePaymentMethodRequired: 'Mindestens eine Zahlungsmethode ist erforderlich',
    invalidTrialPeriod: 'Bitte geben Sie eine gültige Testperiode ein',
    
    // Billing Cycles
    failedToLoadBillingCycles: 'Abrechnungszyklen konnten nicht geladen werden',
    failedToUpdateBillingCycle: 'Abrechnungszyklus konnte nicht aktualisiert werden',
    failedToCreateBillingCycle: 'Abrechnungszyklus konnte nicht erstellt werden',
    failedToRemoveBillingCycle: 'Abrechnungszyklus konnte nicht entfernt werden',
    
    // Credit Management
    failedToLoadCreditManagement: 'Credit-Management-Einstellungen konnten nicht geladen werden',
    failedToSaveCreditManagement: 'Credit-Management-Einstellungen konnten nicht gespeichert werden',
    
    // General API
    requestFailed: 'Anfrage fehlgeschlagen',
    networkError: 'Netzwerkfehler aufgetreten',
    validationError: 'Validierungsfehler',
    failedToLoadCustomers: 'Kunden konnten nicht geladen werden',
    failedToLoadProducts: 'Produkte konnten nicht geladen werden.',
    failedToLoadProduct: 'Produkt konnte nicht geladen werden.',
  } as const;

export default errors;
